import { Pipe, PipeTransform } from '@angular/core';

export enum PaidFeaturesEnum {
  PermanentInspection = 'PermanentInspection',
  GuidedTroubleshooting = 'GuidedTroubleshooting',
  ParameterComparison = 'ParameterComparison',
  DataRecorderAndDataTrending = 'DataRecorderAndDataTrending',
  PredictiveMaintenance = 'PredictiveMaintenance',
  SystemOverview = 'SystemOverview',
  AutomatedRecommendations = 'AutomatedRecommendations',
  ExtendedParameters = 'ExtendedParameters',
}
@Pipe({
  name: 'paidFeatureAvailable',
})
export class PaidFeatureAvailable implements PipeTransform {
  transform(paidFeatures: string[], ...args: string[]): any {
    return isPaidFeatureAvailable(paidFeatures, args[0]);
  }
}

export function isPaidFeatureAvailable(paidFeatures: string[], featureName: string): boolean {
  if (!paidFeatures?.length) {
    return false;
  }

  return !!paidFeatures.find((feature) => feature === featureName);
}
